import { render, staticRenderFns } from "./subproject-item.vue?vue&type=template&id=afe06966"
import script from "./subproject-item.vue?vue&type=script&lang=js"
export * from "./subproject-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports